import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modern-schooling-banner',
  templateUrl: './modern-schooling-banner.component.html',
  styleUrls: ['./modern-schooling-banner.component.scss']
})
export class ModernSchoolingBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
